import { createFileRoute, redirect } from "@tanstack/react-router"

// A household key link (<web>/key#hk=…, lib/household-key.ts): the phone app opens /key itself; in a browser it
// goes to "/" with the hash kept, where the PIN gate claims the key.
export const Route = createFileRoute("/key")({
  beforeLoad: ({ location }) => {
    throw redirect({ to: "/", hash: location.hash, replace: true })
  },
})
